/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';

import type { Rail } from './SharedVenuePage.types';
import { AdditionalLinks } from './AdditionalLinks';
import { ErrorNotification } from './ErrorNotification';

export interface RightRailProps {
    errors?: string[];
    errorRef?: React.RefObject<any>;
    rightRail?: Rail;
    isMainRole?: boolean;
}

export function RightRail({
    isMainRole = false,
    errors = [],
    errorRef,
    rightRail,
}: RightRailProps) {
    if (!rightRail) {
        return null;
    }

    const { title = '', body = null, links, notAuth } = rightRail;

    const unAuthClassName = notAuth ? 'rec-aside-unauth' : '';

    return (
        <div className="rec-venue-page-right-rail">
            <div role={isMainRole ? 'main' : 'complementary'}>
                <div className={`rec-aside-header ${unAuthClassName}`}>
                    <div role="heading" aria-level={2}>
                        {title}
                    </div>
                </div>
                <div className="rec-aside-body">
                    {SecurityHelper.isMobileApp() && (
                        <ErrorNotification
                            className="my-1"
                            errors={errors}
                            errorHeader="You've encountered the following error(s):"
                            innerRef={errorRef}
                        />
                    )}
                    {body}
                </div>

                <AdditionalLinks links={links} />
            </div>
        </div>
    );
}
